import { useConstant } from '@eturi/react'
import { useT } from '@eturi/react-i18next'
import { isInstallingChildApp$ } from '@op/app-shared'
import { useEffect } from 'react'
import { useTypedSelector } from '../../types'
import { InfoModal } from '../../widgets'
import { ChildAppInstallBtn } from './ChildAppInstallBtn'

type ChildAppInstallModalProps = {
	readonly onClose: () => void
	readonly childId: string
	readonly deviceId: string
}

const ChildAppInstallModal = ({ onClose, childId, deviceId }: ChildAppInstallModalProps) => {
	const [t] = useT('devices')

	const isInstallingChildApp = useTypedSelector((s) =>
		isInstallingChildApp$(s, { deviceId, userId: childId }),
	)
	const initialInstallState = useConstant(() => isInstallingChildApp)

	// Close modal if this was opened without the app installing, and installing starts.
	const shouldClose = !initialInstallState && isInstallingChildApp

	useEffect(() => {
		if (shouldClose) onClose()
	}, [shouldClose])

	return (
		<InfoModal hideClose={false} header="OurPact Jr." onClose={onClose}>
			<p>
				{t(
					isInstallingChildApp ?
						'child_app_installed_modal.description'
					:	'device.install_child_app_description',
				)}
			</p>

			<InfoModal.Footer>
				<ChildAppInstallBtn disabled={isInstallingChildApp} childId={childId} deviceId={deviceId} />
			</InfoModal.Footer>
		</InfoModal>
	)
}

export default ChildAppInstallModal
